import { useEffect } from "react";
import { RequestServiceLog } from "interfaces";
import { useGoogleAnalyticsContext } from "contexts";

export function useNetworkLogsObserver(
	setNetworkLogs?: React.Dispatch<React.SetStateAction<RequestServiceLog[]>>
) {
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const isResourceEntry = (
		entry: PerformanceEntry
	): entry is PerformanceResourceTiming => {
		return entry.entryType === "resource";
	};

	useEffect(() => {
		// Prevent double analytics report when debug is enabled
		if (process.env.REACT_APP_WITH_DEBUG !== "false") {
			return;
		}

		const observer = new PerformanceObserver((list) => {
			const newLogs: RequestServiceLog[] = list
				.getEntries()
				.filter(isResourceEntry)
				.filter(
					(entry) =>
						(entry.initiatorType === "fetch" ||
							entry.initiatorType === "xmlhttprequest") &&
						entry.name.startsWith(process.env.REACT_APP_BACKEND_URI || "")
				)
				.map((entry) => ({
					url: entry.name.replace(process.env.REACT_APP_BACKEND_URI || "", ""),
					duration: entry.duration
				}));

			newLogs.forEach((log) => {
				reportPlaygamiEvent("tp.eng.tech_event", {
					system_name: "webstore_performance",
					event_name: "request_latency",
					event_version: 1,
					event_data: JSON.stringify({
						request: log.url,
						time_ms: log.duration.toFixed(2)
					})
				});
			});

			setNetworkLogs?.((prev) => [...prev, ...newLogs]);
		});

		observer.observe({ entryTypes: ["resource"] });

		return () => observer.disconnect();
	}, [setNetworkLogs]);
}
